// extracted by mini-css-extract-plugin
export var container = "_qz-0";
export var dotAnimation = "_qz-2";
export var dotsLoading = "_qz-1";